import { createFileRoute, useParams } from "@tanstack/react-router";
import { EditReportContent } from "@/components/portal/apps/reporting/custom/EditReportContent";

export const Route = createFileRoute(
  "/portal/apps/reporting/custom/$slug_/edit",
)({
  component: EditCustomReportPage,
});

function EditCustomReportPage() {
  const { slug } = useParams({
    from: "/portal/apps/reporting/custom/$slug_/edit",
  });
  return <EditReportContent slug={slug} />;
}
